import React from 'react';

import { t } from '../../utils/i18n';
import { LOGO_ORIENTATION, BEAMER_ID, SEVERITY } from '../../constants';
import Button from '../Button';
import SearchWrapper from '../SearchWrapper';
import SMSInfoMessage from '../SMSInfoMessage';
import Notifications from '../../containers/Notifications';

const getLogoDimensions = () => {
  switch (LOGO_ORIENTATION) {
    case 'LANDSCAPE':
      return { width: 'auto', height: '24px' };
    case 'SQUARE':
    default:
      return { width: '42px', height: '42px' };
  }
};

function Header({
  logoUrl,
  onSearchActivation,
  onClickButton,
  onClickSMSClose,
  company,
  severity,
  isAdmin,
  trackMethod,
}) {
  const handleClickButton = (name) => (event) => {
    onClickButton(name, event);
  };

  const smsDisplayInfo = (clickEvent, severityType, isAdmin) => {
    switch (severityType) {
      case SEVERITY.DANGER:
        return (
          <SMSInfoMessage
            onCloseClicked={clickEvent}
            isHiddenSm
            status={SEVERITY.DANGER}
            isAdmin={isAdmin}
          />
        );

      case SEVERITY.WARNING:
        return (
          <SMSInfoMessage
            onCloseClicked={clickEvent}
            isHiddenSm
            status={SEVERITY.WARNING}
            isAdmin={isAdmin}
          />
        );
      case SEVERITY.NONE:
        return null;

      default:
        return null;
    }
  };

  return (
    <header className="as-Header">
      <div className="as-Header-top">
        <Button
          data-testid="shore-home-button"
          title={t('button.calendar.title')}
          href="/calendar"
          className="as-Header-logoButton"
          onClick={handleClickButton('calendar')}
        >
          {logoUrl && (
            <img
              alt="Logo"
              style={getLogoDimensions()}
              src={logoUrl}
              className="as-Header-logo"
            />
          )}
        </Button>
        <div className="as-Header-searchBox">
          <SearchWrapper
            onActivate={onSearchActivation}
            title={t('button.search.title')}
            placeholder={t('button.search.placeholder')}
          />
        </div>
        {smsDisplayInfo(onClickSMSClose, severity, isAdmin)}
        <Notifications
          isWhitelabelShore={company === 'shore'}
          trackMethod={trackMethod}
          shouldShowProductNotification={Boolean(BEAMER_ID)}
        />
      </div>
    </header>
  );
}

export default Header;
